import React from "react";
import { AppContext } from "../AppContext.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  DatePickerComponent_adv,
  InputTextbox,
  ShowError,
  MultiViewPopup,
  ProgressBar,
  AlertToolBox,
  CollapseComponent,
} from "../gui_components/UIComponents.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress
} from "../gui_components/Util.js";
import { Button, FormLabel, Row, Col, Table } from "react-bootstrap";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import {
  CustomerSearchCriteria,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  FabricStyleSearchCriteria,
  RestReadRequest,
  FabricStyleSKUBean,
  FabricStyleBean,
  BookingReportCriteriaBean,
  BookingPrintRequest,
  RestCustomerListRequest,
} from "../ds/ds.js";
import { CustomerService } from "../services/CustomerService.js";
import { RestReportBean, BaseBean } from "../ds/client_ds.js";
import { ReportService } from "../services/ReportService.js";
import { AddIcon } from "../gui_components/Icons.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager";
import { DropDwnUp, DropDwnDown } from "../gui_components/Icons.js";
import {
  PopupCustomerModule,
  PopupFabricModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { ConfigManager } from "../config/ConfigManager.js";
class BookingReport extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.customerCodeRef = React.createRef();
    this.state = {
      pageTitle: "Booking Report Inquiry",
      isShowExitButton: true,
      isShowExecuteButton: true,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      error_list: [],
      isShowAlert: false,
      alertType: "",
      alertMessage: [],
      isInquiryDatasFound: false,
      inquiryDataList: [],
      inquiryLineData: [],
      inquiryData: [],
      criteria: new BookingReportCriteriaBean(),
      colorList: [],
      fabricStyleData: new FabricStyleBean(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      fabricLookupHandler: null,
      colorLookupHandler: null,
      customerLookupHandler: null,
      isShowColorLookup: false,
      isShowLinePopup: false,
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricColorList: true,
      showAutoCompleteCustomerList: true,
      customerPageListForAutoCompleteList: new Array(),
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowLookup: true,
      isDisableFields: false,
      moduleForPopup: [],
      isCollapsible_open: true,
      order: "asc",
      sortField: "",
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage();
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadBookingReportInquiryList(criteria);
  };
  loadBookingReportInquiryList = (listRequest) => {
    if (SecurityAccessManager.BookingReportInquiry_IsAccessible()) {
      ReportService.inquireBookingReportResultDetails(
        listRequest,
        this.loadBookingReportInquiryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadBookingReportInquiryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let bookingInfoBean = new Array();
      let resultData = new Array();
      if (!isEmptyArray(response.data.result.bookingInfoBean)) {
        resultData = response.data.result;
        bookingInfoBean = response.data.result.bookingInfoBean;
        this.setState({
          isShowExcelButton: true,
          isShowPDFButton: true,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        inquiryDataList: bookingInfoBean,
        inquiryData: resultData,
        isShowClearCriteriaButton: false,
        isShowResetButton: true,
        isShowColorLookup: false,
        isShowLookup: false,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error" + error);
  };
  showHideSecondHeader = () => {
    let tempIsCollapsible_open = !this.state.isCollapsible_open;
    this.setState({ isCollapsible_open: tempIsCollapsible_open });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowSalesModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowLinePopup: isShowPopup,
    });
  };
  clearCriteria = () => {
    let criteria = new BookingReportCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isShowColorLookup: false,
      isCollapsible_open: true,
    });
    this.hideAlertCallBack();
  };
  reset = () => {
    let criteria = new BookingReportCriteriaBean();
    criteria.companyCode = this.companyCode;
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isDisableFields: false,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowClearCriteriaButton: true,
      isShowLookup: true,
      isCollapsible_open: true,
      isShowColorLookup: false,
    });
    this.hideAlertCallBack();
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  generatePDF = () => {
    this.generateBookingReportInquiryReport(1);
  };
  generateExcel = () => {
    this.generateBookingReportInquiryReport(2);
  };
  generateBookingReportInquiryReport = (reportType) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new BookingPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    if (reportBean.reportType == 1) {
      if (SecurityAccessManager.BookingReportInquiryPDFReport_IsAccessible()) {
        ReportService.generateBookingPrintReport(
          listRequest,
          this.generateBookingReportInquiryPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.BookingReportInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateBookingPrintReport(
          listRequest,
          this.generateBookingReportInquiryPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateBookingReportInquiryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generateBookingReportInquiryPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
       window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
          });
        }
      }
    }
  };

  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.fabricStyleColorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };

  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList == true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ critera: tempCriteria });
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let customer_pageList = new RestPageListBean();
    customer_pageList.pageSize = 100;
    let customer_requestInput = new RestCustomerListRequest();
    customer_requestInput.pageInput = customer_pageList;
    customer_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      customer_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesOrderModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  lineDetail = (e, data) => {
    if (e.detail === 1) {
      let inquiryLineData = new Array();
      if (!isEmptyArray(data.bookingDataBean)) {
        inquiryLineData = data.bookingDataBean;
      }
      this.setState({
        inquiryLineData: inquiryLineData,
        isShowLinePopup: true,
      });
    }
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      // this.setState({
      //   isShowProgressBarPopup: true,
      //   progressLoadingText: "Sorting ...",
      // });
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
    // this.setState({
    //   isShowProgressBarPopup: false,
    //   progressLoadingText: "",
    // });
  };
  handleSortingLineDataChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingLineData(sortField, sortOrder);
    }
  };
  handleSortingLineData = (sortField, sortOrder) => {
    let list = this.state.inquiryLineData;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryLineData: sorted });
    }
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inquiryLineData = this.state.inquiryLineData;
    let inquiryData = this.state.inquiryData;
    return (
      <div>
        {" "}
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          hideAlertCallBack={this.hideAlertCallBack}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExitButton={this.state.isShowExitButton}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          clearCriteria={this.clearCriteria}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          reset={this.reset}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          showHideSecondHeader={this.showHideSecondHeader}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
        />
        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            <Table id="fabrics_tables">
              <thead>
                <th></th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleCode")
                  }
                >
                  {this.state.is3PL ? "Item#" : "FabricStyle#"}
                  {this.state.order === "desc" &&
                  this.state.sortField === "fabricStyleCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "fabricStyleName")
                  }
                >
                  {this.state.is3PL ? "Item Name" : "FabricStyle Name"}
                  {this.state.order === "desc" &&
                  this.state.sortField === "fabricStyleName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "colorCode")}>
                  Color
                  {this.state.order === "desc" &&
                  this.state.sortField === "colorCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "openQuantity")}
                >
                  OpenQuantity
                  <br />
                  {this.state.order === "desc" &&
                  this.state.sortField === "openQuantity" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                  <div class="bg-white text-danger">
                    
                    {toCommaSeperatedAmount(inquiryData.totalOpenQuantity)}
                  </div>{" "}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "qty")}>
                  Quantity
                  <br />
                  {this.state.order === "desc" &&
                  this.state.sortField === "qty" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                  <div class="bg-white text-danger">
                    
                    {toCommaSeperatedAmount(inquiryData.totalQuantity)}
                  </div>
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "amount")}>
                  Amount
                  <br />
                  {this.state.order === "desc" &&
                  this.state.sortField === "amount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                  <div class="bg-white text-danger">
                  
                    {toCommaSeperatedAmount(inquiryData.totalAmount)}
                  </div>
                </th>
              </thead>
              <tbody>
                {inquiryDataList.map((data, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.lineDetail(e, data)}
                      >
                        <AddIcon></AddIcon>
                      </Button>
                    </td>
                    <td>
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewFabricModule(e, data.fabricStyleCode)
                        }
                      >
                        {data.fabricStyleCode}
                      </Button>
                    </td>
                    <td>{data.fabricStyleName}</td>
                    <td>{data.colorCode}</td>
                    <td className="text-right">{toCommaSeperatedAmount(data.openQuantity)}</td>
                    <td className="text-right">{toCommaSeperatedAmount(data.qty)}</td>
                    <td className="text-right">{toCommaSeperatedAmount(data.amount)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            {inquiryDataList.length != 0 ? null : (
              <div className="no_Data">{"No Data"}</div>
            )}
            <MultiViewPopup
              isModulePopup={false}
              isShowPopup={this.state.isShowLinePopup}
              closeOnEsc={false}
              title={"Line Details"}
              closeAlertModalCallBack={this.closeAlertModalCallBack}
              closeOnDocumentClick={false}
              popupLvlClass={"popupSizeLevel0"}
              alertContainerBox={
                <AlertToolBox
                  alertMsgList={this.state.alertMessage}
                  alertErrorType={this.state.alertType}
                  isShowAlert={this.state.isShowAlert}
                  hideAlertCallBack={this.hideAlertCallBack}
                />
              }
              content={
                <div className="div_default">
                  <Table id="fabrics_tables">
                    <thead>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(e, "customerCode")
                        }
                      >
                        Customer
                        {this.state.order === "desc" &&
                        this.state.sortField === "customerCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(e, "customerName")
                        }
                      >
                        CustomerName
                        {this.state.order === "desc" &&
                        this.state.sortField === "customerName" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(
                            e,
                            "salesOrderNumber"
                          )
                        }
                      >
                        SO#
                        {this.state.order === "desc" &&
                        this.state.sortField === "salesOrderNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(e, "salesOrderDate")
                        }
                      >
                        So Date
                        {this.state.order === "desc" &&
                        this.state.sortField === "salesOrderDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(
                            e,
                            "salesOrderStartDate"
                          )
                        }
                      >
                        So StartDate
                        {this.state.order === "desc" &&
                        this.state.sortField === "salesOrderStartDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(
                            e,
                            "salesOrderStopDate"
                          )
                        }
                      >
                        So StopDate
                        {this.state.order === "desc" &&
                        this.state.sortField === "salesOrderStopDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(e, "salesPerson")
                        }
                      >
                        SalesPerson
                        {this.state.order === "desc" &&
                        this.state.sortField === "salesPerson" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(e, "salesPersonName")
                        }
                      >
                        SalesPersonName
                        {this.state.order === "desc" &&
                        this.state.sortField === "salesPersonName" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(e, "openQuantity")
                        }
                      >
                        OpenQuantity
                        {this.state.order === "desc" &&
                        this.state.sortField === "openQuantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(e, "quantity")
                        }
                      >
                        Quantity
                        {this.state.order === "desc" &&
                        this.state.sortField === "quantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLineDataChange(e, "amount")
                        }
                      >
                        Amount
                        {this.state.order === "desc" &&
                        this.state.sortField === "amount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </thead>
                    <tbody>
                      {inquiryLineData.map((data, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewCustomerModule(e, data.customerCode)
                              }
                            >
                              {data.customerCode}
                            </Button>
                          </td>
                          <td>{data.customerName}</td>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewSalesOrderModule(
                                  e,
                                  data.salesOrderNumber
                                )
                              }
                            >
                              {data.salesOrderNumber}
                            </Button>
                          </td>
                          <td>{data.salesOrderDate}</td>
                          <td>{data.salesOrderStartDate}</td>
                          <td>{data.salesOrderStopDate}</td>
                          <td>{data.salesPerson}</td>
                          <td>{data.salesPersonName}</td>
                          <td className="text-right">{toCommaSeperatedAmount(data.openQuantity)}</td>
                          <td className="text-right">{toCommaSeperatedAmount(data.quantity)}</td>
                          <td className="text-right">{toCommaSeperatedAmount(data.amount)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {inquiryLineData.length != 0 ? null : (
                    <div className="no_Data">{"No Data"}</div>
                  )}
                </div>
              }
            />
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricStyleModule}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowCustomerModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel1"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          isShowPopup={this.state.isShowSalesModule}
          id="moduleForPopup"
          popupLvlClass={"popupSizeLevel1"}
          closeOnEsc={false}
          module={this.state.moduleForPopup}
          closeModalCallBack={this.closeModalCallBack}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const customerCodeOnChange = (e) => {
    props.customerCodeOnChange(e);
  };
  const fabricCodeOnChange = (e) => {
    props.fabricCodeOnChange(e);
  };
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const showHideSecondHeader = (e) => {
    if (e.detail === 1) props.showHideSecondHeader();
  };
  let customerLookupHandler = props.customerLookupHandler;
  let fabricLookupHandler = props.fabricLookupHandler;
  const customerCodeRef = props.customerCodeRef;
  let fabricCodeRef = React.createRef();
  let colorCodeRef = React.createRef();
  let criteria = props.criteria;

  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={customerCodeOnChange}
            lookupRequired={props.isShowLookup}
            value={criteria.customerCode}
            lookupHandler={customerLookupHandler}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            displayAutoCompleteList={displayAutoCompleteList}
            enableAutoCompleteTextBox={true}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>From Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="fromOrderDate"
            value={criteria.fromOrderDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col sm="1">
          <FormLabel>To Date</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="toOrderDate"
            value={criteria.toOrderDate}
            onChange={onChange}
            disabled={props.isDisableFields}
          />
        </Col>
        <Col md={0.9}>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => showHideSecondHeader(e)}
          />
        </Col>
      </Row>

      {props.isCollapsible_open && (
        <Row>
          <Col sm="1">
            {props.is3PL ? (
              <FormLabel>Item</FormLabel>
            ) : (
              <FormLabel>FabricStyle</FormLabel>
            )}
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={fabricCodeRef}
              name="fabricStyleCode"
              onChange={fabricCodeOnChange}
              value={criteria.fabricStyleCode}
              lookupRequired={props.isShowLookup}
              lookupHandler={fabricLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={fabricEnterKeyEventHandler}
              autoCompleteListData={props.fabricPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteFabricList}
              showAutoCompleteList={props.showAutoCompleteFabricList}
              disabled={props.isDisableFields}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="fabricStyleName"
              onChange={onChange}
              value={criteria.fabricStyleName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Color</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={colorCodeRef}
              onChange={onFabricColourCodeChange}
              name="colorCode"
              placeholder="color"
              value={criteria.colorCode}
              lookupRequired={props.isShowColorLookup}
              lookupHandler={props.colorLookupHandler}
              enterKeyEventHandler={fabricColourEnterKeyEventHandler}
              autoCompleteListData={
                props.fabricColourPageListForAutoCompleteList
              }
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteFabricColorList}
              showAutoCompleteList={props.showAutoCompleteFabricColorList}
              disabled={!props.isShowColorLookup}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function BookingReportInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <BookingReport {...props} name="" /> <br />
    </div>
  );
}

export default BookingReportInquiry;
